import type { ExamRouteState } from "../types";

const GENIUS_STARTING_SOON_EXAM_STATE_KEY = "genius_starting_soon_exam_state";

type SessionStorageLike = {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
};

function getSessionStorage(): SessionStorageLike | null {
  if (typeof globalThis === "undefined") return null;
  const g = globalThis as { sessionStorage?: SessionStorageLike };
  return g.sessionStorage ?? null;
}

export type GeniusStartingSoonExamState = ExamRouteState & {
  fromGeniusDeeplink?: boolean;
};

export function persistGeniusStartingSoonExamState(
  state: GeniusStartingSoonExamState,
): void {
  try {
    getSessionStorage()?.setItem(
      GENIUS_STARTING_SOON_EXAM_STATE_KEY,
      JSON.stringify(state),
    );
  } catch {
    // ignore
  }
}

export function readGeniusStartingSoonExamState(): GeniusStartingSoonExamState | null {
  try {
    const raw = getSessionStorage()?.getItem(
      GENIUS_STARTING_SOON_EXAM_STATE_KEY,
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GeniusStartingSoonExamState;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearGeniusStartingSoonExamState(): void {
  try {
    getSessionStorage()?.removeItem(GENIUS_STARTING_SOON_EXAM_STATE_KEY);
  } catch {
    // ignore
  }
}
